import Spratt6 from './assets/spratt6.jpg';
import Spratt7 from './assets/spratt7.jpg';
import Spratt8 from './assets/spratt8.jpg';
import Spratt9 from './assets/spratt9.jpg';
import Spratt10 from './assets/spratt10.jpg';
import Spratt11 from './assets/spratt11.jpg';
import Chandra from './assets/chandra.jpg';



export const housePlantsDB = [
    {
        id: 1,
        picture: Spratt6
    },
    {
        id: 2,
        picture: Spratt7
    },
    {
        id: 3,
        picture: Spratt8
    },
    {
        id: 4,
        picture: Spratt9
    },
    {
        id: 5,
        picture: Spratt10
    },
    {
        id: 6,
        picture: Spratt11
    },
    {
        id: 7,
        picture: Chandra
    },
]